import { Box, Breadcrumbs, Typography } from "@mui/material"
import { useStyles } from "./styles"
import { HouseIcon } from "../../../../mp-core/icons"
import { LinkRouter } from "./LinkRouter"
import { RoutesPathnames } from "./types"
import { useBreadcrumbs } from "./hooks"
import { useHistory } from "react-router-dom"

interface Props {
  routesPathnames: RoutesPathnames[]
  baseUrl?: string
  homeUrl?: string
  guardedActionsMap?: Record<string, () => void>
}

const MPBreadcrumbs = <T extends { [K in keyof T]?: string }>(props: Props) => {
  const { baseUrl, routesPathnames, homeUrl, guardedActionsMap } = props
  const { classes } = useStyles()
  const history = useHistory()

  const { links, currentRoute } = useBreadcrumbs<T>(baseUrl, routesPathnames)

  const onBreadcrumbClick = (path: string, isDisabled = false) => {
    if (!currentRoute.isGuarded && !isDisabled) {
      history.push(path)
      return
    }

    if (!guardedActionsMap[currentRoute.name]) {
      throw new Error("Action for guarded route not found.")
    }
    guardedActionsMap[currentRoute.name]?.()
  }

  return (
    <Box className={classes.сontainer}>
      <Breadcrumbs aria-label="Breadcrumbs">
        <LinkRouter
          underline="none"
          color="inherit"
          onClick={() => onBreadcrumbClick(homeUrl ?? `/${baseUrl}`)}
          className={classes.link}
        >
          <HouseIcon />
        </LinkRouter>
        {links
          .filter(link => link)
          .map(link => {
            const { to, name, isDisabled, isLast } = link
            return isLast ? (
              <Typography color="textPrimary" variant="body2" key={to}>
                {link?.name ?? ""}
              </Typography>
            ) : (
              <LinkRouter
                underline="none"
                color="inherit"
                onClick={() => onBreadcrumbClick(to, isDisabled)}
                key={to}
                className={classes.link}
                disabled={isDisabled}
              >
                <Typography variant="body2">{name ?? ""}</Typography>
              </LinkRouter>
            )
          })}
      </Breadcrumbs>
    </Box>
  )
}

export default MPBreadcrumbs
